import { useMutation } from '@tanstack/react-query';
import { requestResetLink } from '@/services/forgot-password.service';
import type { RequestResetLinkRequest } from '@/services/forgot-password.types';

export type RequestResetLinkValues = RequestResetLinkRequest;

interface UseRequestResetLinkMutationArgs {
  onSuccess: () => void;
  onError: () => void;
}

const useRequestResetLinkMutation = ({
  onSuccess,
  onError,
}: UseRequestResetLinkMutationArgs) =>
  useMutation({
    mutationFn: (values: RequestResetLinkValues) => requestResetLink(values),
    onSuccess,
    onError,
  });

export default useRequestResetLinkMutation;
